exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/renta-pensiones/renta-pensiones.component.css
// module id = ../../../../../src/app/components/formulario-no-experto/secciones/renta-pensiones/renta-pensiones.component.css
// module chunks = main